import autoload from './autoload';
import auth from './mixins/auth';
import cart from './mixins/cart';
import initDom from './mixins/init_dom';

autoload();

window.app = new Vue({
  el: '#vue-policies-and-terms',

  mixins: [initDom, auth, cart],

  data() {
    return {
      goTo: window._PR?.goTo || '',
    }
  },

  mounted() {
    let vm = this;
    if (vm.goTo.length) {
      setTimeout(function(){
        vm.scrollTo('#'.concat(vm.goTo));
      }, 500);
    }
  },
});
